import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { UserRole } from '../models/general.models';
import RouteAuthorizer from './components/RouteAuthorizer';
import { AppRoutes } from './routes';
var ListPage = React.lazy(function () { return import('../pages/list/list.page'); });
var listRedirectPages = [
    {
        userRole: UserRole.Anonymous,
        page: AppRoutes.Intro,
    },
    {
        userRole: UserRole.NoCountryUser,
        page: AppRoutes.Intro,
    },
    {
        userRole: UserRole.PartialUser,
        page: AppRoutes.JoinFamily,
    },
    {
        userRole: UserRole.UserPaymentNeeded,
        page: AppRoutes.SubscriptionPage,
    },
    {
        userRole: UserRole.PlanPendingUser,
        page: AppRoutes.OnboardingWelcomePage,
    },
    // rimuovere il redirect per UserRole.CompleteUser qualora si volesse aggiungere nuovamente la pagina di lista della spesa su WEB
    {
        userRole: UserRole.CompleteUser,
        page: AppRoutes.Plan,
    },
];
var listRoutes = [
    {
        path: AppRoutes.List,
        element: (_jsx(RouteAuthorizer, { userRoles: [], redirectPages: listRedirectPages, children: _jsx(ListPage, {}) })),
    },
];
export default listRoutes;
